(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gd-availability-inquiry"] && !Shopify.designMode) return;
  try {
    function openAvailabilityInquiry() {
    if (window.location.hash !== '#gd-availability') return;
    const target = document.getElementById('gd-availability');
    const details = target?.querySelector('details');
    if (details) {
      details.open = true;
      target.scrollIntoView({ block: 'start' });
    }
  }
  openAvailabilityInquiry();
  window.addEventListener('hashchange', openAvailabilityInquiry);
  document.addEventListener('shopify:section:load', openAvailabilityInquiry);
  } catch(e) { console.error(e); }
})();

})();
